import api from "./api";
import axios from "axios";
import Cookies from "js-cookie";

const register = (data) => {
  return api.post("auth/register", data);
};

const getUser = (userId) => {
  return api.get(`users/${userId}`);
};

const getCurrentUser = () => {
  return api.get(`me`).then((response) => {
    const { data } = response;
    return data;
  });
};

const login = (username, password) => {
  return api
    .post("auth/login", {
      username,
      password,
    })
    .then((response) => {
      const { data } = response;
      return data;
    });
};

const logout = () => {
  return api
    .post("auth/logout")
    .then((resp) => {
      console.log("Logout Response", resp);
    })
    .catch((err) => console.log("Logout error", err));
};

const refreshToken = async () => {
  const response = await axios.post(
    "api/auth/refresh-token",
    {},
    {
      headers: {
        "Content-Type": "application/json",
        withCredentials: true,
        "X-CSRF-TOKEN": Cookies.get("csrf_refresh_token"),
      },
    }
  );
  return response;
};

export default {
  register,
  login,
  logout,
  getUser,
  refreshToken,
  getCurrentUser,
};
